export const capitalize = (string = '') => (string || '').replace(/^\w/, (c) => c.toUpperCase());
//# sourceMappingURL=capitalize.js.map